import styled from 'styled-components';
import {theme} from '@styles/theme';

export const NotAvailable = styled.div`
  color: ${theme.colors.basic03};
  font-style: italic;
`;

export const TableContainer = styled.div`
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

export const TableHeader = styled.thead`
  background-color: ${theme.colors.basic08};
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableHeaderCell = styled.th`
  padding: 16px 8px;
  text-align: left;
  border: 1px solid ${theme.colors.basic06};
  background-color: ${theme.colors.basic07};
  overflow: hidden;
  text-overflow: ellipsis;
  &:first-child {
    padding: 16px 8px 16px 24px;
  }
  &:first-child {
    width: 296px;
  }
`;

export const TableCell = styled.td`
  padding: 8px;
  border: 1px solid ${theme.colors.basic06};
  position: relative;
  text-overflow: ellipsis;
  &:not(:first-child) {
    &:hover {
      background-color: ${theme.colors.basic07};
    }
  }
  &:first-child {
    width: 296px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AddIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 8px;
`;

export const SortIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 8px;
`;

export const ModuleCellContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
`;

export const ModuleName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModuleNameWithEdit = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 19px;
  padding-right: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TestCellContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CoverageDetails = styled.div`
  display: flex;
  gap: 8px;
`;

export const CoverageDetailBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const EditButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
